import React, { useState, useCallback } from 'react';
import { AutoComplete, Input, Spin, Button, message } from 'antd';
import debounce from 'lodash/debounce';
import GoogleMapReact from 'google-map-react';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { authRequest } from '../../../../../../common/request/authRequest';
import { CenterMarker } from '../../_drawers/components/CenterMarker';

export const BusinessAutocomplete = (props: { onBusinessSelect: any }) => {
  
  const [options, setOptions] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState<any>(null); 
  const { projectGroup } = useAuth();    

  const fetchBusinessData = async (searchText: string) => {
    if (!searchText) return;
    
    setLoading(true);
    
    await authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/places/autocomplete?q=${searchText}`, { method: 'GET' })
        .then((data) => {                
            const formatted = (data.autocomplete || []).map((item: any) => ({
    
                label: `${item.title} - ${item.address}`,
                value: `${item.title} - ${item.address}`,
                data: item 
            }));
            setOptions(formatted);
        }).catch((error) => {
            console.error("Error buscando negocios:", error);
        }).finally(() => {
            setLoading(false); 
        });
  }

  const addSelectedLocation = async () => {
    if (!selectedBusiness) {
      console.error("No hay ningún negocio seleccionado");
      return;
    }
    
    const payload = {
      ...selectedBusiness
    };
    
    authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/places`, {
        method: 'POST', 
        data: payload
    })   
    .then((res: any) => {          
        message.success("Negocio guardado con éxito");
        props.onBusinessSelect();
    })
    .catch((error : any) => {          
      message.info("Problema al guardar el negocio");      
    });                
  };  

  const debouncedSearch = useCallback(
    debounce((nextValue: string) => fetchBusinessData(nextValue), 500),
    [projectGroup.project]
  );

  const handleSearch = (value: string) => {
    setSelectedBusiness(null); 
    setOptions([]);
    debouncedSearch(value);
  };

  const handleSelect = (value: string, option: any) => {    
    
    authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/places/address?address=${encodeURIComponent(option.data.title + ' ' + option.data.address)}`, { method: 'GET' })
    .then((res: any) => {                  
      
      const businessWithCoords = {
        ...option.data, 
        gps_coordinates: {
          latitude: res.lat,
          longitude: res.lng
        }
      };
      
      setSelectedBusiness(businessWithCoords);
      message.success("Coordenadas obtenidas correctamente");
          
      })
    .catch((error : any) => {          
      message.info("Problema al obtener coordenadas");      
    });          
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <AutoComplete
        dropdownMatchSelectWidth={true}
        style={{ width: '100%' }}
        options={options}
        onSelect={handleSelect}
        //onChange={handleSelect}
        onSearch={handleSearch}
        notFoundContent={loading ? <Spin size="small" /> : 'No se encontraron negocios'}
      >
        <Input.Search 
          size="large" 
          placeholder="Escribe el nombre de tu negocio..." 
          loading={loading}
          enterButton 
        />
      </AutoComplete>
      {selectedBusiness && 
                <div style={{ height: '400px', width: '100%', marginTop: '20px' }}>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: "AIzaSyCtmjrbwFhUPNP-LfETh_aAKaFuZJhwDm4" }}
                        defaultCenter={{ lat: 0, lng: 0 }}
                        center={{ lat: selectedBusiness.gps_coordinates.latitude, lng: selectedBusiness.gps_coordinates.longitude}}
                        //center={{ lat: 0, lng: 0 }}
                        //defaultZoom={10}
                        zoom={16}
                        yesIWantToUseGoogleMapApiInternals>
                            
                        <CenterMarker 
                            lat={selectedBusiness.gps_coordinates.latitude}
                            lng={selectedBusiness.gps_coordinates.longitude}
                            />    
                    </GoogleMapReact>
                </div>
            }         
      
      {selectedBusiness && (
        <Button type="primary" onClick={addSelectedLocation} block>
          <b>Confirmar y Añadir: {selectedBusiness.title}</b>
        </Button>
      )}
    </div>
  );
};